import { StrictMode } from 'react';

import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/700.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';

import App from '@/app';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      // gcTime: 5 * 60_000,
      refetchOnMount: 'always',
      refetchOnWindowFocus: 'always',
    },
  },
});

/**
 * By default, React Query Devtools are only included in bundles when process.env.NODE_ENV === 'development',
 * so we don't need to worry about excluding them during a production build.
 * https://tanstack.com/query/v5/docs/framework/react/devtools
 */
declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__?: import('@tanstack/query-core').QueryClient;
  }
}

if (import.meta.env.DEV) {
  window.__TANSTACK_QUERY_CLIENT__ = queryClient;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
